/** @format */
import Header from "../../components/home/header/header";
import Footer from "../../components/molecules/footer";
import Button from "../../components/atoms/button";
import Card from "../../components/home/card";
import MoneyAndPhone from "../../assets/images/money and phone.svg";
import chart from "../../assets/images/chart window with analytics.svg";
import elipse from "../../assets/images/Ellipse 10.svg";
import socials from "../../assets/images/socials.svg";
import rect from "../../assets/images/Rectangle 244.svg";
import wave from "../../assets/images/Rectangle 245.svg";
import gif from "../../assets/images/Comp.gif";
import {
  ElipseOverlay,
  IconOverlay,
  RectangleOverlay,
  WaveOverlay,
  Container,
  Heading,
  H1,
  Description,
  HalfCard,
  CardH,
  HalfCardD,
  Explore,
  Bottom,
} from "./styles";
import Reveal from "../../components/atoms/reveal";

const Home = () => {
  return (
    <div className=" overflow-hidden  w-[100%] relative ">
      <ElipseOverlay
        animate={{
          // rotate: 360,
          scale: [1, 1.2, 1.1, 1.3, 1],
        }}
        transition={{
          ease: "linear",
          duration: 20,
          repeat: Infinity,
          x: { duration: 1 },
        }}
      >
        <img src={elipse} alt="" />
      </ElipseOverlay>
      <IconOverlay
        animate={{
          rotate: [360, 0, -360, 0, 360],
          x: [-100, 0, 100, 0, -50],
        }}
        transition={{
          ease: "linear",
          duration: 500,
          repeat: Infinity,
          x: { duration: 300 },
        }}
      >
        <img src={socials} alt="" />
      </IconOverlay>
      <RectangleOverlay>
        <img src={rect} alt="" />
      </RectangleOverlay>
      <WaveOverlay>
        <img src={wave} alt="" />
      </WaveOverlay>
      <Header />
      <Container>
        <Reveal>
          <Heading>
            <H1>Upgrade Your Digital Portfolio</H1>
            <Description>
              <p>
                A single page that stores your links, videos, ideas, blog and
                every other thing that makes you awesome
              </p>
            </Description>
            <Button value="Join Path" toUrl="/login" variant="primary" />
          </Heading>
        </Reveal>

        <Reveal>
          <HalfCard>
            <CardH>
              <p>
                Path.ng / <span>yourname</span>
              </p>
            </CardH>
            <h1>Claim your Path Page</h1>
            <HalfCardD>
              Connect your Instagram, Linkedin, Tiktok, X , blogs, ideas,
              events, website, store, podcast, videos, music, and more in one
              beautiful portfolio page.
            </HalfCardD>
            <Button value="Join Path" toUrl="/login" variant="primary" />
            <Explore href="/usecases">explore use cases</Explore>
          </HalfCard>
        </Reveal>

        <Reveal>
          <Card variant="secondary">
            <div className="p-14">
              <img src={gif} alt="" />
            </div>
            <div>
              <h1>Smart Networking</h1>
              <p>
                Network with finesse using your customized and enhanced Near
                Field Communication (NFC) card. Tapping your Path Business Card
                on any compatible smart phone would instantly open your path
                Page.
              </p>
              <Button value="Join Path" toUrl="/login" variant="primary" />
            </div>
          </Card>
        </Reveal>
        <Reveal>
          <Card variant="primary">
            <div>
              <img src={MoneyAndPhone} alt="" />
            </div>
            <div>
              <h1>Commission-Free</h1>
              <p>
                What you earn is yours! With 'Path,' 100% of your earnings from
                sales or donations, go directly to your bank account. No hidden
                fees, no commission,
              </p>
              <Button value="Join Path" toUrl="/login" variant="secondary" />
            </div>
          </Card>
        </Reveal>
        <Reveal>
          <Card variant="secondary">
            <div>
              <img src={chart} alt="" />
            </div>
            <div>
              <h1>Powerful Insights and Analytics</h1>
              <p>
                Analyze link clicks, page views and other things, and make
                informed decisions that would help you keep your audiences
                engaged{" "}
              </p>
              <Button value="Join Path" toUrl="/login" variant="primary" />
            </div>
          </Card>
        </Reveal>
        <Bottom>
          <h1>Streamline your Digital Presence</h1>
          <Button value="Join Path" toUrl="/login" variant="primary" />
        </Bottom>
      </Container>
      <Footer />
    </div>
  );
};

export default Home;
